import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import LoadingWrapper from 'components/common/LoadingWrapper';

const AssetSummary = ({ summaryData, loading }) => {
  return (
    <Grid container>
      <LoadingWrapper loading={loading}>
        <strong id='Asset_Summary'>{summaryData.description}</strong>
      </LoadingWrapper>
    </Grid>
  );
};

AssetSummary.propTypes = {
  summaryData: PropTypes.object,
  loading: PropTypes.bool.isRequired
};

export default AssetSummary;
